import Loadable from '../../components/loadable';

const ChangeVerifiedPhoneNumberModal = Loadable({
  loader: () => import('../../pages/user_profile/change_verified_phone_number_modal'),
  type: 'modal',
});

angular.module('gym').value('ChangeVerifiedPhoneNumberModal', ChangeVerifiedPhoneNumberModal);
